import React from 'react';

export const ValorantInfoSection = ({ content }) => {
  return (
    <section className="valorant-info-section">
      <h6 className="valorant-info-section__heading">
        Lifetime Warranty on All Valorant Accounts
      </h6>
      <p className="valorant-info-section__paragraph">
        Our Valorant accounts include a lifetime warranty, offering you further
        piece of mind. We are so confident in the quality of our accounts that
        we are the only Valorant account supplier who gives and guarantees a
        lifetime warranty on all accounts purchased. If your smurf account is
        banned or has any flaws, we will provide you with a new comparable
        account. New LoL accounts will be given in accordance with our Terms of
        Service.
      </p>
      <div className="valorant-info-section__features">
        <p className="valorant-info-section__feature-item">
          Instant 24/7 Delivery
        </p>
        <div className="valorant-info-section__feature-item-separator" />

        <p className="valorant-info-section__feature-item">Lifetime Warranty</p>
        <div className="valorant-info-section__feature-item-separator" />
        <p className="valorant-info-section__feature-item">
          Secure Payment Options
        </p>
        <div className="valorant-info-section__feature-item-separator" />
        <p className="valorant-info-section__feature-item">
          Human Leveled Accounts
        </p>
        <div className="valorant-info-section__feature-item-separator" />

        <p className="valorant-info-section__feature-item">
          Over 5000 5* Reviews
        </p>
      </div>
      <div className="valorant-info-section__text-section">
        <img
          className="valorant-info-section__visual-mobile"
          src="/images/valorant/valorant_agent.png"
          alt="valorant agent"
        />
        <h6 className="valorant-info-section__heading">
          {content.secondTitle}
        </h6>
        {content.secondContent.map((paragraph) => (
          <p className="valorant-info-section__paragraph">
            {paragraph}
          </p>
        ))}
      </div>
      <div className="valorant-info-section__how-it-works">
        <div className="valorant-info-section__how-it-works-container">
          <img
            className="valorant-info-section__visual"
            src="/images/valorant/valorant_agent.png"
            alt="valorant agent"
          />
          <h6 className="valorant-info-section__how-it-works-container-underlay-heading">
            How It Works
          </h6>
          <div className="valorant-info-section__how-it-works-row">
            <ValorantInfoSectionHowItWorksItem
              icon="cart"
              heading="Add To Cart"
              description="Choose the account you like the most and add to cart"
            />
            <i className="valorant-info-section__how-it-works-icon fa fa-chevron-right" />
            <ValorantInfoSectionHowItWorksItem
              icon="money"
              heading="Checkout"
              description="Pay with one of the 200 payment methods available"
            />
            <i className="valorant-info-section__how-it-works-icon fa fa-chevron-right" />
            <ValorantInfoSectionHowItWorksItem
              icon="delivery"
              heading="Delivery"
              description="Within 1 min receive an account and instructions how to verify and care for it"
            />
            <i className="valorant-info-section__how-it-works-icon fa fa-chevron-right" />
            <ValorantInfoSectionHowItWorksItem
              icon="support"
              heading="24/7 Support"
              description="customer support with over 10 years of experience in helping our customers"
            />
          </div>
        </div>
      </div>

      <h6 className="valorant-info-section__heading">
        {content.thirdTitle}
      </h6>
        {content.thirdContent.map((paragraph) => (
          <p className="valorant-info-section__paragraph">
            {paragraph}
          </p>
        ))}
      <h6 className="valorant-info-section__heading">
        Account safety should be your top priority while using a Valorant
        account.
      </h6>
      <p className="valorant-info-section__paragraph">
        The last thing you want is a low-quality botted account that gets banned
        for no reason after you've spent hours climbing the ranks. We provide a
        free, permanent guarantee on all the accounts we make, and each one is
        expertly crafted and leveled by hand by our team of account creators.
        UnrankedSmurfs accounts are forever try what thousands of customers
        vouch for!
      </p>
    </section>
  );
};

const ValorantInfoSectionHowItWorksItem = ({ heading, description, icon }) => {
  return (
    <div className="valorant-info-section__how-it-works-item">
      <img
        src={`/images/valorant/icons/${icon}.svg`}
        className="valorant-info-section__how-it-works-item-icon"
      />

      <div className="valorant-info-section__how-it-works-item-text-container">
        <p className="valorant-info-section__how-it-works-item-text-heading">
          {heading}
        </p>

        <p className="valorant-info-section__how-it-works-item-text-description">
          {description}
        </p>
      </div>
    </div>
  );
};
